import type { Device } from "@tandemdiabetes/sugarmate-api-react-client"
import { useSaveDevice } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useDevice } from "./useDevice"
import type { PartialWithId } from "src/types"
import { noticeError } from "src/utils"

export function useUpdateDevice() {
  const saveDevice = useSaveDevice()
  const { mutate } = useDevice()

  return useMemo(
    () => saveDevice && (async (device: PartialWithId<Device>) => {
      try {
        const response = await saveDevice(device)

        void mutate(response.data.device)
        return response
      } catch (e) {
        noticeError(
          e,
          "UpdateDevice",
          { device },
        )

        throw e
      }
    }),
    [
      saveDevice,
      mutate,
    ],
  )
}
